import { Badge, Box, Button, Flex, Image, Link, Text } from "@chakra-ui/react";
import React from "react";
import { ExternalLinkIcon } from "@chakra-ui/icons";

const Projects = () => {
  const projects = [
    {
      id: 1,
      name: "Mini Projects",
      description:
        "Explore my web development journey through a collection of mini projects, showcasing my learnings, skills, creativity, and growth in the field.",
      image:
        "https://github-production-user-asset-6210df.s3.amazonaws.com/98752820/268849646-041ae5d4-972b-422b-8740-edcb5a94c01d.png",
      techStack: ["HTML", "CSS", "Javascript","ReactJS", "Python","Tailwind CSS", "Open-Ai", "Chakra-UI", "Angular"],
      github: "https://github.com/Ajay84sia/Mini-Projects",
      demo: "https://ajay84sia-miniprojects.netlify.app/",
    },
    {
      id: 2,
      name: "Buy Digital",
      description:
        "Buy Digital is a clone of an e-commerce website Reliance Digital which sells all electronic products at the best possible price.",
      image:
        "https://user-images.githubusercontent.com/98752820/230615900-9cd5e1d0-3a9e-4a65-a354-7afc9097a79e.png",
      techStack: ["HTML", "CSS", "Javascript", "bootstrap", "json-server"],
      github: "https://github.com/Ajay84sia/Buy-Digital",
      demo: "https://buy-digital.netlify.app/",
    },
    {
      id: 3,
      name: "Soundarya",
      description:
        "Soundarya is a clone of an e-commerce website Bath & Body Works which sells soaps, lotions, fragrances, and candles.",
      image:
        "https://user-images.githubusercontent.com/98752820/230616358-61548aea-5b19-4842-b11e-b2bea0dc5190.png",
      techStack: ["HTML", "CSS", "Javascript", "bootstrap", "json-server"],
      github: "https://github.com/Ajay84sia/Soundarya",
      demo: "https://soundaryaa.netlify.app/",
    },
    {
      id: 4,
      name: "Urban Studio",
      description:
        "Urban Studio is a clone of an e-commerce website AJIO which sells clothes, shoes and accessories for men, women and kids.",
      image:
        "https://user-images.githubusercontent.com/98752820/230618007-8d174e53-d3a1-49b3-8bfb-1cacf5bee251.png",
      techStack: ["ReactJs", "JavaScript", "css", "chakra ui", "json-server"],
      github: "https://github.com/Ajay84sia/Urban-Studio",
      demo: "https://urbanstudio.netlify.app/",
    },
    {
      id: 5,
      name: "Tackle & Trail",
      description:
        "Tackle & Trail is a clone of an e-commerce website Basspro which sells quality fishing, hunting, boating and outdoor sporting goods.",
      image:
        "https://user-images.githubusercontent.com/98752820/230619027-6e6090e1-1a45-4944-8004-e02d949dd97e.png",
      techStack: [
        "React Js",
        "Redux",
        "chakra ui",
        "Auth0",
        "Chart Js",
        "Stripe Checkout",
      ],
      github: "https://github.com/Ajay84sia/Tackle_and_Trail",
      demo: "https://tackle-and-trail.netlify.app/",
    },
    {
      id: 6,
      name: "Jewel Lane",
      description:
        "Jewel Lane is a clone of an e-commerce website Caratlane which sells the best gold & diamond jewellery.",
      image:
        "https://github.com/Satyamjha24/Jewellane/assets/98752820/4cad9755-4102-4b93-b8a2-7087eaebf875",
      techStack: [
        "React Js",
        "Redux",
        "chakra ui",
        "Node js",
        "Express js",
        "Mongo DB",
        "Chart Js",
        "Stripe",
      ],
      github: "https://github.com/Ajay84sia/Jewel-Lane",
      demo: "https://jewellane.vercel.app/",
    },
    {
      id: 7,
      name: "BUYC",
      description:
        "BUYC is a marketplace for second-hand cars. Dealers list their inventory of second-hand cars on BUYC website.",
      image:
        "https://github-production-user-asset-6210df.s3.amazonaws.com/98752820/267400329-d7fa1073-d0c9-4beb-b6fd-4353296783f7.png",
      techStack: [
        "React Js",
        "Redux",
        "Javascript",
        "chakra ui",
        "Node js",
        "Express js",
        "Mongo DB",
        "Mongoose",
      ],
      github: "https://github.com/Ajay84sia/BUYC",
      demo: "https://buyc-attryb.netlify.app/",
    },
    {
      id: 8,
      name: "Study Wave Campus",
      description:
        "Study Wave is a comprehensive Learning Management System that provides secure authentication and efficient administration.",
      image:
        "https://user-images.githubusercontent.com/98752820/267399856-e17735ed-9496-40f1-96c3-e917a590862e.png",
      techStack: [
        "Angular",
        "Typescript",
        "Tailwind CSS",
        "Auth0",
        "Chart Js",
        "Python",
        "Django",
        "Mongo DB"
      ],
      github: "https://github.com/Ajay84sia/StudyWave_Campus",
      demo: "https://study-wave-campus.netlify.app/",
    },
    {
      id: 9,
      name: "Image Searching App",
      description:
        "Explore the world through images with ease! Our image search app simplifies visual discovery, making it effortless to search and enjoy.",
      image:
        "https://github-production-user-asset-6210df.s3.amazonaws.com/98752820/269671255-d13fdce2-c5df-433f-9b53-0a5517624d1e.png",
      techStack: [
        "Next Js",
        "Javascript",
        "Tailwind CSS",
        "Unsplash API"
      ],
      github: "https://github.com/Ajay84sia/Mini-Projects/tree/main/codebase/image-search",
      demo: "https://image-searching.vercel.app/",
    },
  ];

  return (
    <Box id="projects" paddingTop={"10vh"} width={"88vw"} marginLeft={{base:"20px"}}>
      <Text fontSize="4xl" fontWeight="600" margin="auto" textAlign="center">
        Projects
      </Text>
      <Box
        // height={["325vh", "190vh", "135vh"]}
        display="grid"
        gridTemplateColumns={[
          "repeat(1,1fr)",
          "repeat(2,1fr)",
          "repeat(3,1fr)",
        ]}
        gap="25px"
        marginTop={"30px"}
      >
        {projects.map((el, i) => {
          return (
            <Box
              border="3px solid teal"
              height="auto"
              data-aos="flip-left"
              data-aos-easing="linear"
              data-aos-duration="1000"
              borderRadius={"21px"}
              className="project-card"
              key={i}
            >
              <Image src={el.image} borderTopRadius={"20px"} />
              <Box className="description" padding={"10px"}>
                <Box className="project-tech-stack">
                  {el.techStack.map((tech) => {
                    return (
                      <Badge
                        marginRight={"10px"}
                        borderRadius="full"
                        px="2"
                        colorScheme="teal"
                      >
                        {tech}
                      </Badge>
                    );
                  })}
                </Box>
                <Text
                  fontSize="2xl"
                  marginTop={"10px"}
                  marginBottom={"10px"}
                  textAlign={"center"}
                  className="project-title"
                >
                  {el.name}
                </Text>
                <Text marginBottom={"10px"} className="project-description">{el.description}</Text>
                <Flex justifyContent="space-around" marginBottom={"0px"}>
                  <Box className="project-deployed-link">
                    <Link href={el.demo} isExternal>
                      <Button>
                        Demo
                        <Text as="span" ml={"2"}>
                          <ExternalLinkIcon />
                        </Text>
                      </Button>
                    </Link>
                  </Box>
                  <Box className="project-github-link">
                    <Link href={el.github} isExternal>
                      <Button>
                        Github
                        <Text as="span" ml={"2"}>
                          <ExternalLinkIcon />
                        </Text>
                      </Button>
                    </Link>
                  </Box>
                </Flex>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Projects;
